import {ObjectWorldTransform} from '../Class/ObjectWorldTransform';

interface HoldArg {
  intersection: any;
  raycaster: any;
  selectedObjects: any[];
}

interface MoveArg {
  staticObjects: any[];
  draggedObjects: any[];
  raycaster: any;
  draggedObject: any;
  draggedObjectWorldTransform: ObjectWorldTransform;
}

interface ReleaseArg {
  staticObjects: any[];
  draggedObjects: any[];
}

export class DragHandlerBase {

  protected nextHandler: DragHandlerBase | undefined;

  constructor(nextHandler?: DragHandlerBase) {
    this.nextHandler = nextHandler;
  }

  hold(e: Readonly<HoldArg>) {
    if (this.nextHandler) {
      this.nextHandler.hold(e);
    }
  }

  move(e: Readonly<MoveArg>, transform: ObjectWorldTransform) {
    if (this.nextHandler) {
      this.nextHandler.move(e, transform);
    }
  }

  release(e: Readonly<ReleaseArg>) {
    if (this.nextHandler) {
      this.nextHandler.release(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Handler/drag-handler-base.ts